module.exports = __webpack_public_path__ + "static/img/set.1a16111.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/set.png
// module id = W+Gm
// module chunks = 136